// Access-control surface copy — the `/pending` holding page a signed-in but
// not-yet-approved account lands on (no Loom access yet, so it says the
// public name, root `CLAUDE.md`), plus the shared status/level vocabulary
// reused by the admin table (admin.ts). User-facing chrome only.

import { PUBLIC_PRODUCT_NAME } from "@loom/shared/brand";

import type { MsgSection } from "./types.js";

export const access: MsgSection = {
  // --- Pending-approval page ---
  "access.pending.title": {
    en: "Your account is awaiting approval",
    de: "Dein Konto wartet auf Freigabe",
  },
  "access.pending.body": {
    en: `You've signed in successfully, but an administrator still needs to approve your access before you can use ${PUBLIC_PRODUCT_NAME}. You'll get in as soon as that happens — try again later.`,
    de: `Du hast dich erfolgreich angemeldet, aber eine Administratorin muss deinen Zugriff noch freigeben, bevor du ${PUBLIC_PRODUCT_NAME} nutzen kannst. Sobald das geschehen ist, hast du Zugang — versuche es später erneut.`,
  },
  "access.pending.signOut": { en: "Sign out", de: "Abmelden" },
  "access.pending.recheck": { en: "Check again", de: "Erneut prüfen" },

  // --- Shared status vocabulary (status enum) ---
  "access.status.pending": { en: "Pending", de: "Ausstehend" },
  "access.status.approved": { en: "Approved", de: "Freigegeben" },
  "access.status.blocked": { en: "Blocked", de: "Gesperrt" },

  // --- Shared level vocabulary (grant level enum) ---
  "access.level.create_only": { en: "Create only", de: "Nur erstellen" },
  "access.level.full": { en: "Full", de: "Voll" },
};
